export default __webpack_public_path__ + "static/media/pdf.afc90820.svg";